import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 600);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-brand-night border-t border-brand-border shadow-2xl p-4 z-50" data-id="element-104">
      <div className="max-w-4xl mx-auto flex items-center justify-between" data-id="element-105">
        <div className="hidden md:block" data-id="element-106">
          <p className="font-bold text-brand-cream text-sm" data-id="element-107">
            Deep Sleep Cortisol Reset
          </p>
          <p className="text-xs text-brand-muted" data-id="element-108">Instant Digital Download</p>
        </div>
        <div className="flex items-center gap-4 w-full md:w-auto" data-id="element-109">
          <div className="text-right mr-2 hidden sm:block" data-id="element-110">
            <span className="block text-xs text-brand-muted line-through" data-id="element-111">
              $97
            </span>
            <span className="block font-bold text-brand-amber text-xl" data-id="element-112">
              $6,39
            </span>
          </div>
          <Button onClick={scrollToPricing} className="w-full md:w-auto py-3 text-base" data-id="element-113">
            Get The Protocol
          </Button>
        </div>
      </div>
    </div>;
}